import { BlockOverrides } from 'baseui/block';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      display: 'flex',
      justifyContent: 'flex-start',
      paddingTop: '32px',
      paddingBottom: '4px',
    },
  },
};

export const HEADING: BlockOverrides = {
  Block: {
    style: {
      marginTop: '8px',
      marginBottom: 0,
      fontSize: '24px',
      fontWeight: 600,
    },
  },
};
